import React from 'react';
import {
  Grid,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIos';
import { useHistory } from 'react-router-dom';

import { useSelector } from 'react-redux';
import useStyles from './styles';
import { ReduxState } from '../../types';

function CustomHeader({
  title,
  ActionButton,
  TabsComponent,
  showBackButton = true,
  onBack,
  sectors = false,
}: {
  title: string,
  ActionButton?: JSX.Element,
  TabsComponent?: JSX.Element,
  showBackButton?: boolean,
  onBack?: () => void,
  sectors?: boolean
}) {
  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const classes = useStyles();
  const history = useHistory();
  const sectorTitle = title.split('/')[1];
  const currentSectorPosition = selectedFarm?.sectors?.findIndex(
    (sector) => sector.name === sectorTitle,
  );
  const shouldShowBackButton = showBackButton
    && !TabsComponent;

  const handleSectorBack = () => {
    if (currentSectorPosition !== undefined
      && currentSectorPosition > 0) {
      const previousSector = selectedFarm?.sectors?.[currentSectorPosition - 1];
      history.push(`/sectores/${previousSector?.id}`
        + `?farmId=${selectedFarm?.id}`);
    }
  };

  const handleSectorForward = () => {
    if (currentSectorPosition !== undefined
      && currentSectorPosition < (selectedFarm?.sectors?.length || 0) - 1) {
      const nextSector = selectedFarm?.sectors?.[currentSectorPosition + 1];
      history.push(`/sectores/${nextSector?.id}`
        + `?farmId=${selectedFarm?.id}`);
    }
  };

  const parsedTitle = title.split('/').map((elem, index, arr) => {
    if (index === (arr.length - 1)) {
      return <React.Fragment key={index}>
        {' '}
        {sectors && <ArrowBackIcon onClick={handleSectorBack} sx={{ fontSize: '16px', marginRight: '4px', cursor: 'pointer' }} />}
        <span className={classes.activePageUnderlined}>
          {elem.trim()}
        </span>
        {sectors && <ArrowForwardIcon onClick={handleSectorForward} sx={{ fontSize: '16px', marginLeft: '4px', cursor: 'pointer' }} />}
      </React.Fragment>;
    }
    return (
      <React.Fragment key={index}>
        {elem.trim()} /
      </React.Fragment>
    );
  });

  const handleGoBack = () => {
    if (onBack) {
      onBack();
    } else {
      history.goBack();
    }
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className={classes.gridCustomHeader}
      spacing={3}
    >
      <Grid item xs>
        <Box display="flex" alignItems="center">
          {shouldShowBackButton && !sectors && (
            <IconButton onClick={handleGoBack} aria-label="go back">
              <ArrowBackIcon />
            </IconButton>
          )}
          <Typography
            variant="h3"
            color="textPrimary"
            sx={{ ml: shouldShowBackButton ? 1 : 0 }}
          >
            {parsedTitle}
          </Typography>
        </Box>
      </Grid>
      {ActionButton && <Grid item>
        {ActionButton}
      </Grid>}
      {TabsComponent && (
        <Grid item>
          <Box>
            {TabsComponent}
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

export default CustomHeader;
